var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginVectorBotLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 493,
    viewBox: "0 0 490 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_46_23824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-296.746 394.571C-261.568 289.52 -182.109 215.421 -96.2317 160.458C-16.1449 109.2 75.4346 73.7202 158.31 103.322C236.308 131.183 269.911 225.061 310.487 305.734C351.193 386.662 420.347 470.054 389.273 562.513C358.644 653.651 255.078 669.181 176.313 704.973C118.833 731.092 63.2434 733.446 2.9181 738.077C-99.0109 745.902 -220.995 820.572 -290.572 740.815C-361.78 659.189 -335.275 509.628 -296.746 394.571Z",
    fill: "url(#paint0_linear_46_23824)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-296.746 394.571C-261.568 289.52 -182.109 215.421 -96.2317 160.458C-16.1449 109.2 75.4346 73.7202 158.31 103.322C236.308 131.183 269.911 225.061 310.487 305.734C351.193 386.662 420.347 470.054 389.273 562.513C358.644 653.651 255.078 669.181 176.313 704.973C118.833 731.092 63.2434 733.446 2.9181 738.077C-99.0109 745.902 -220.995 820.572 -290.572 740.815C-361.78 659.189 -335.275 509.628 -296.746 394.571Z",
    stroke: "#F2F4F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_46_23824",
    x: -427.656,
    y: 0.0527344,
    width: 917.223,
    height: 869.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46,
    result: "effect1_foregroundBlur_46_23824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_23824",
    x1: 305.636,
    y1: 906.431,
    x2: 349.201,
    y2: 40.9793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C7D1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginVectorBotLeft);
export default __webpack_public_path__ + "static/media/login-vector-botLeft.ec0197924425e8234a91c9e5dc2a5652.svg";
export { ForwardRef as ReactComponent };